<template>
	<div class="wrap">
		<dataBank :dialogVisible="dialogVisible" @closeEdit="closeEdit" @pushData="pushData1"></dataBank>
		<localBank :showlocal="showlocal" @closeLocal="closeLocal" @pushData="pushData"></localBank>
		<!-- 自定义标签弹窗 -->
		<AddTags :tagsWin="tagsWin" @closeTagWin="closeTagWin" @addtgs="addtgs"></AddTags>
		<div class="navbar">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>组织生活</el-breadcrumb-item>
				<el-breadcrumb-item>三会一课</el-breadcrumb-item>
				<el-breadcrumb-item>{{$route.query.type == 'add'?'新增三会一课':'编辑三会一课'}}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="datawrap">
			<div class="datatable">
				<div class="datas">
					<div class="contrl_bar">
						<el-button type="primary"
						size="small"
						@click="$router.go(-1)">返回</el-button>
					</div>
					<div class="addTitle">{{$route.query.type == 'add'?'新增三会一课':'编辑三会一课'}}</div>
					<div class="addWrap">
						<el-form 
							label-position="center"
							label-width="80px"
							ref="formData" 
							:model="formData" 
							:rules="rules">
							<el-form-item class="form_item" label="活动主题" prop="title">
								<el-input
									placeholder="请输入活动主题"
									v-model="formData.title">
								</el-input>
							</el-form-item>
							<el-form-item class="form_item" label="活动时间" prop="h_stime">
								<el-date-picker
									v-model="formData.h_stime"
									type="datetime"
									format="yyyy-MM-dd HH:mm"
									:default-time="'09:00:00'"
									placeholder="请选择活动时间"
									value-format="timestamp">
								</el-date-picker>
							</el-form-item>
							<el-form-item class="form_item" label="参与组织" prop="u_id">
								 <el-cascader
									v-model="formData.u_id"
									ref="cascaderAddr"
									@change="szzlist"
									:options="zzlist"
									:props="props"
									collapse-tags
									filterable
									placeholder="请选择参与组织"
									clearable></el-cascader>
							</el-form-item>
							<el-form-item class="form_item" label="活动类型" prop="tid">
								<el-select
									v-model="formData.tid" placeholder="请输入活动类型">
									<el-option
										v-for="item in typeList"
										:label="item.type"
										:value="item.id">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item class="form_item" label="活动地点" prop="h_address">
								<el-input
									placeholder="请输入活动地点"
									v-model="formData.h_address">
								</el-input>
							</el-form-item>
							<el-form-item class="form_item" label="活动标签" prop="">
								<div class="biaoqian">
									<el-tag
										:key="index"
										v-for="(tag,index) in dynamicTags"
										:closable="tag.name!='主题党日'&&tag.name!='民主生活会'&&tag.name!='组织生活会'"
										@click="tag.checked=!tag.checked"
										:disable-transitions="false"
										:type="tag.checked?'success':'info'"
										@close="handleClose(tag)">
										{{tag.name}}
									</el-tag>
									<el-button 
										class="button-new-tag"
										size="small" 
										v-if="dynamicTags.length < 5"
										@click="tagsWin=true">自定义</el-button>
								</div>
							</el-form-item>
							<el-form-item class="form_item" label="活动封面" prop="img">
								<el-upload
									:data="{token:$store.state.user.userinfo.token}"
									name="file"
									:action="$uploadImg"
									:show-file-list="false"
									:on-success="success"
									:before-upload="$limitImg">
									<img v-if="imageUrl" :src="imageUrl" class="fengmian">
									<el-button size="small"  type="primary">{{imageUrl == null || imageUrl == ''?'上传封面':'重新上传'}}</el-button>
									<div class="tishi">支持格式：jpg、png，图片不得大于2M</div>
								</el-upload>
							</el-form-item>
							<el-form-item class="form_item" label="集中学习" prop="focus" style="margin-top: -15px;">
								<el-switch
									style="margin-top: 12px;"
									:inactive-value="2"
									:active-value="1"
									v-model="formData.focus">
								</el-switch>
							</el-form-item>
							<el-form-item v-if="formData.focus == 1" class="form_item" label="学习课时" prop="focus">
								<el-input-number v-model="formData.hour"  :min="0"  label="学习课时"></el-input-number>
							</el-form-item>
							<el-form-item class="form_item" label="心得体会" prop="">
								<el-switch
									style="margin-top: 12px;"
									inactive-value="2"
									active-value="1"
									v-model="formData.tips">
								</el-switch>
							</el-form-item>
							<el-form-item class="form_item fuwenben" style="padding-bottom: 70px;" v-if="formData.h_stime!=''&&formData.h_stime<new Date().getTime()" label="活动记录"  prop="record">
								<quill-editor :options="$VueQuillEditor" ref="myTextEditor" v-model="formData.record" style="height:327px !important;width: 800px;"></quill-editor>
							</el-form-item>
							<el-form-item class="form_item" label="活动资料"  prop="">
								<el-button size="small" type="info" plain @click="showlocal = true">本地添加</el-button>
								<el-button size="small" type="primary" plain @click="dialogVisible = true">资料库添加</el-button>
							</el-form-item>
							<div class="fileList" v-if="formData.file.length > 0">
								<div class="fileItem" v-for="(item,index) in formData.file">
									<div class="fileIcon" v-if="item.bs_id == 8"><img src="@/assets/images/pdfBg.png" ></div>
									<div class="fileIcon" v-if="item.bs_id == 3"><img src="@/assets/images/videoBg.png" ></div>
									<div class="fileIcon" v-if="item.bs_id == 1"><img src="@/assets/images/pptBg.png" ></div>
									<div class="fileIcon" v-if="item.bs_id == 2"><img src="@/assets/images/pdfBg.png" ></div>
									<div class="fileName">{{item.title}}</div>
									<div class="fileDel" title="删除" @click="delfile(index)"><i class="el-icon-delete"></i></div>
								</div>
							</div>
							<el-form-item class="form_item submit">
								<el-button type="primary" @click="submit('formData')">发布</el-button>
								<el-button @click="$router.go(-1)">取消</el-button>
							</el-form-item>
						</el-form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import shyk_add from './mixins/shyk_add.js'
	export default{
		mixins: [shyk_add],
	}
</script>

<style lang="scss">
	.wrap{
		width: 100%;
		position: relative;
		color: $index_color;
		font-size: index_size1;
		.addTitle{
			width: 100%;
			border-bottom: 1px solid #DDE2EE;
			padding-bottom: 15px;
			margin: -40px 0 20px 0;
			font-size: 18px;
			color: #333333;
			font-weight: bold;
			width: 80%;
		}
		.el-input{
			width: 220px !important;
		}
		.addWrap{
			.form_item{
				width: 100%;
				margin-bottom: 15px;
				display: flex !important;
				align-items: flex-start !important;
				font-size: 14px;
				.fengmian{
					display: inline-block;
					vertical-align: bottom;
					height: 150px;
					margin-right: 10px;
					margin-left: 0;
					width: 223px;
				}
				.tishi{
					font-size: 12px;
					color: rgb(131, 138, 157);
					margin-top: 10px;
				}
				.el-upload{
					text-align: left !important;
				}
				.biaoqian{
					width: 500px;
					.el-tag {
						margin-right: 10px;
					}
				}
			}
			.el-form-item__content{
				margin-left: 0 !important;
			}
			.fuwenben{
				padding-bottom: 110px;
			}
			.submit{
				padding-left: 85px;
			}
			.el-form-item__error{
				position: relative !important;
				margin-left: 20px;
				line-height: 30px;
			}
		}
	}
</style>
